import React, { useEffect } from "react";
import { HeaderBullet } from "@ugg/shared/components/common/HeaderBullet";
import { ReactComponent as IconX } from "svg/x.svg";
import { Icon } from "@ugitgud/legos/ui/icon/Icon";
import { SvgMiscPaypal } from "@ugitgud/legos/ui/icon/SVG/MiscPaypal";
import { SvgMiscCreditCard } from "@ugitgud/legos/ui/icon/SVG/MiscCreditCard";

interface PaymentMethod {
  label: string;
  type: "card" | "paypal";
}

interface DeletePaymentMethodModalProps {
  onClose: () => void;
  onConfirm: () => void;
  isLoading: boolean;
  paymentMethod: PaymentMethod | null;
}

const DeletePaymentMethodModal: React.FC<DeletePaymentMethodModalProps> = ({ onClose, onConfirm, isLoading, paymentMethod }) => {
  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "inherit";
    };
  }, []);

  return (
    <div>
      {/* Overlay */}
      <div className="fixed z-modal-overlay inset-0 bg-purple-500 bg-opacity-75" onClick={onClose} />

      {/* Modal */}
      <div className="fixed z-modal-content top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[400px] h-auto rounded-[3px] bg-purple-200 overflow-hidden">
        {/* Header */}
        <div className="flex items-center justify-between p-4.5 bg-purple-200">
          <HeaderBullet>Delete Payment Method</HeaderBullet>
          <IconX className="w-[14px] cursor-pointer [&_path]:fill-white" onClick={onClose} />
        </div>

        {/* Content */}
        <div className="p-4.5 bg-purple-400">
          <p className="text-lavender-50 text-sm mb-4.5">You are about to delete the following:</p>

          {/* Payment Method Display */}
          {paymentMethod && (
            <div className="inline-flex items-center gap-2.5 px-3 py-2.5 mb-4.5 bg-lavender-500 rounded-[3px]">
              {paymentMethod.type === "paypal" ? (
                <Icon icon={<SvgMiscPaypal />} className="w-5 h-3.5" />
              ) : (
                <Icon icon={<SvgMiscCreditCard />} className="w-5 h-3.5" />
              )}
              <span className="text-white text-sm font-medium">{paymentMethod.label}</span>
            </div>
          )}

          <p className="text-lavender-50 text-sm mb-4.5">You can always add it back later if needed.</p>

          {/* Buttons */}
          <div className="flex justify-center gap-4.5">
            <button
              onClick={onConfirm}
              disabled={isLoading}
              className="flex-1 h-9 bg-accent-blue-400 hover:bg-accent-blue-400/80 px-2.5 px-3 text-white text-[13px] font-semibold rounded-[3px] transition-colors disabled:opacity-50"
            >
              {isLoading ? "Deleting..." : "Confirm"}
            </button>
            <button
              onClick={onClose}
              disabled={isLoading}
              className="flex-1 h-9 bg-lavender-500 hover:bg-lavender-500/80 px-2.5 px-3 text-white text-[13px] font-semibold rounded-[3px] transition-colors disabled:opacity-50"
            >
              Go back
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeletePaymentMethodModal;
